import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Grid } from "@mui/material";

import ActiveAccounts from "../../components/NewDashboard/ActiveAccounts";
import Badge from "../../components/NewDashboard/Badge";
import {
  fetchNewDashboard,
  fetchPerformanceChart,
} from "../../store/reducers/dashboardReducer";
import "../../components/NewDashboard/NewDashboard.scss";
import Loader, { Loader2 } from "../../reusableComponents/Loader";
import BalanceChart from "../../components/Charts/BalanceChart";

const NewDashboard = () => {
  const loader = useSelector((state) => state.loader.is_loading);
  const [refreshData, setRefreshData] = useState(false);
  const [open, setOpen] = useState(loader);
  useEffect(() => {
    setOpen(loader);
  }, [loader]);
  const chartLoader = useSelector((state) => state.loader.chart_is_loading);
  const [chartLoading, setChartLoading] = useState(false);
  useEffect(() => {
    setChartLoading(chartLoader);
  }, [chartLoader]);

  const dispatch = useDispatch();

  const dashboard = useSelector((state) => state.dashboard.newdashboard);
  const SavePerformance = useSelector(
    (state) => state.dashboard.SavePerformance
  );

  useEffect(() => {
    dispatch(fetchNewDashboard());
  }, [dispatch]);

  const [chartData, setChartData] = useState();
  useEffect(() => {
    setChartData(SavePerformance);
    console.log(SavePerformance, "DASHBOARD");
  }, [SavePerformance]);

  const user_profile = useSelector((state) => state.user);

  useEffect(() => {
    if (user_profile) {
      dispatch(
        fetchPerformanceChart(
          user_profile?.current_account,
          user_profile?.current_platform
        )
      );
    }
  }, [dispatch]);

  const { theme } = useSelector((state) => state.theme);

  return (
    <Grid
      container
      item
      className="new-dashboard PageContainer"
      style={{ position: "relative" }}
    >
      {!refreshData && <Loader open={open} />}

      <div style={{ width: "100%" }}>
        {/* ROW 1 */}
        <div
          className="new-row"
          style={{ display: "flex", flexDirection: "column" }}
        >
          {/* <div className="lineR" style={{ display: "flex", gap: "2rem" }}>
            <div className="chartCon">
              <p>Balance-Equity Chart</p>
              <div className="chartConDiv">
                <Loader2 open={chartLoading} />
                <BalanceChart PerformanceChart={chartData} theme={theme} />
              </div>
            </div>
            {dashboard && dashboard.trader_badge && (
              <Badge
                stage={dashboard?.trader_badge?.status}
                data={dashboard?.trader_badge}
              />
            )}
          </div> */}

          <ActiveAccounts
            data={dashboard && dashboard?.accounts}
            theme={theme}
          />
        </div>
      </div>
      {/* ROW 2 */}
      {/* <div style={{width:'100%'}}
      >
        <Challenges />
        <DiscordAnn data={dashboard && dashboard.competition} />
        <TwitterUpdates />
      </div> */}
    </Grid>
  );
};

export default NewDashboard;
